import Vue from "vue";

// 1 az全球购 2 火龙购
export var appSource = 2;

// 所需替换的文本 &, 为分隔符，多文案同一替换时用分隔符组合
const replaceTextMap = {
  "https://assets-apk.myazstore.com/store-retail/az_android_app_qqg.apk": {
    2: "https://assets-apk.mkyun.com/store-retail/hhl_android_app_mky.apk",
  },
  "https://assets-apk.myazstore.com/store-distributor-new/az_android_app_hht.apk": {
    2: "https://assets-apk.mkyun.com/store-distributor/hhl_android_app_msb.apk",
  },
  ".myaz.com": {
    2: ".mkyun.com",
  },
  "assets-js.myazstore.com": {
    2: "assets-img.mkyun.com",
  },
  "assets.img.myazstore.com": {
    2: "assets-img.mkyun.com",
  },
  ".myazstore.com": {
    2: ".mkyun.com",
  },
  "Myaz.com": {
    2: "Mkyun.com",
  },
  "azg公司立足澳新，联动国内，走向世界": {
    2: "杭州火火龙进出口有限公司是一家专注于互联网电子商务领域的公司，特别是服务于海外品牌在中国市场的落地和发展。公司利用自研的M2C智能零售系统，致力于为品牌和渠道提供全链路解决方案，帮助品牌加快传统线下业态与线上电商的融合，提升品牌的渠道渗透率和影响力。",
  },
  azg公司: {
    2: "杭州火火龙进出口有限公司",
  },
  "全球好货通全球": {
    2: "智慧赋能渠道，连接全球好品牌",
  },
  "甄选品质好货 分享品位生活": {
    2: "让健康与美好生活触手可及",
  },
  "AZ全球购&,az全球购&,全球购&,azg": {
    2: "妙客云",
  },
  "az好货通&,好货通": {
    2: "妙商宝",
  },
  // 购: {
  //   2: "云",
  // },
  通: {
    2: "宝",
  },
  az好货: {
    2: "妙商",
  },
  az全球: {
    2: "妙客",
  },
  az: {
    2: "",
  },
  地推宝: {
    2: "妙推客",
  },
  沈阳金蚁电子商务有限公司: {
    2: "杭州火火龙进出口有限公司",
  },
  沈阳金蚁: {
    2: "杭州火火龙",
  },
  // 全球购的appid
  "1544947865": {
    2: "6752891250",
  },
  // 好货通的appid
  "1531836585": {
    2: "6752891231",
  },
  "info@alpha-hk.com": {
    2: "info@mkyun.com",
  },
  辽ICP备2022005380号: {
    2: "浙ICP备2025154514号",
  },
  "辽B2-20210246": {
    2: "浙B2-2025154514",
  },
  中国杭州市滨江区: {
    2: "中国杭州市滨江区",
  },
  "建业路599号华业发展中心3301-3305室": {
    2: "建业路599号华业发展中心10层1020室",
  },
  "@/": {
    1: "",
    2: "assets-hhl/",
  },
};

function initAppSource() {
  if (window.location.hostname.includes("myaz")) {
    appSource = 1;
  } else if (window.location.hostname.includes("mkyun")) {
    appSource = 2;
  } else {
    appSource = 2;
  }
}

export function initGlobal() {
  initAppSource();
  Vue.prototype.$G = globalReplace;
  Vue.prototype.$appSource = appSource;
}

export function initLanguage(language) {
  initAppSource();
  return appSource == 1 ? language : "zh";
}

export function configTitle() {
  let title = "";
  if (appSource == 1) {
    title = "azg官网";
  } else if (appSource == 2) {
    title = "妙客云官网";
  } else {
    title = "azg官网";
  }
  document.title = title;
}

// 获取favicon路径
function getFaviconPath() {
  const prefixMap = { 1: "", 2: "hhl-" };
  return "/" + prefixMap[appSource] + "favicon.ico";
}

// 动态修改网站图标
export const changeFavicon = () => {
  const iconUrl = getFaviconPath();
  // 检查页面是否已有 favicon 标签
  let link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "shortcut icon";
  link.href = iconUrl;
  console.log(document.getElementsByTagName("head")[0]);

  // 如果 favicon 标签已经存在，替换它；否则，添加新标签
  document.getElementsByTagName("head")[0].appendChild(link);
  console.log(document.getElementsByTagName("head")[0]);
};

export function $G(string) {
  return globalReplace(string);
}

// export function $src(string) {
//   const result = replaceText(string, "@-/", replaceTextMap["@-/"]);
//   return require(result);
// }

function globalReplace(string) {
  if (string === "@/") {
    return replaceTextMap["@/"][appSource];
  }

  if (appSource === 1) {
    return string;
  }

  // let result = string.toLowerCase();
  let result = string;
  Object.entries(replaceTextMap).some(([key, value]) => {
    let targetString = key;
    if (targetString.includes("&,")) {
      targetString = targetString.split("&,");
    }
    if (typeof targetString === "string") {
      const replaceResult = replaceText(result, targetString, value);
      if (replaceResult != result && replaceResult.includes("https://")) {
        result = replaceResult;
        return true;
      }
      result = replaceResult;
    } else if (Array.isArray(targetString)) {
      targetString.forEach((item) => {
        result = replaceText(result, item, value);
      });
    }
    return false;
  });
  return result;
}

function replaceText(string, key, value) {
  let result = string;
  if (string.includes(key)) {
    const regex = new RegExp(key, "g");
    const replaceT = value[`${appSource}`];
    result = result.replace(regex, replaceT);
  }
  return result;
}
